import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ClarityInCare from "./sections/ClarityInCare";
import MythVsReality from "./sections/MythVsReality";
import PathsToBetterHealth from "./sections/PathsToBetterHealth";
import LatestInsights from "./sections/LatestInsights";
import TheVisualGlossary from "./sections/TheVisualGlossary";
import JoinTheCircleOfCare from "./sections/JoinTheCircleOfCare";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ClarityInCare />
      <MythVsReality />
      <PathsToBetterHealth />
      <LatestInsights />
      <TheVisualGlossary />
      <JoinTheCircleOfCare />
      <Footer />
    </div>;
}